import { render, staticRenderFns } from "./addOpen.vue?vue&type=template&id=2ec8605b&scoped=true&"
import script from "./addOpen.vue?vue&type=script&lang=js&"
export * from "./addOpen.vue?vue&type=script&lang=js&"
import style0 from "./addOpen.vue?vue&type=style&index=0&id=2ec8605b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8605b",
  null
  
)

export default component.exports